import api from './api';
// import './api-copy';

export default {
  install: (Vue) => {
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$api = api;
  },
};
